import { RawHtml } from '@hyphengroup/cms-components/components/RawHtml/RawHtml';
import { useLocaleSpecificClient } from 'hooks/useSpecificClient';
import { staticText } from 'utils/staticText';

const translations = staticText({
  howTo: {
    _: 'How to Qualify?',
    'zh-hk': '如何參加',
    'zh-tw': '活動詳情',
  },
});

export const PromotionCardsHowTo = (props: { text: string }) => {
  const text = useLocaleSpecificClient(translations.howTo);
  return (
    <div className="flex flex-col gap-spacing/gap/soft-12px">
      <h4 className="mhg-alpha-typography-bullet-1">{text}</h4>
      <RawHtml
        className="cms-rich-text max-w-full !text-font-size/body-1 !leading-line-height/body-1-relaxed"
        content={props.text}
      ></RawHtml>
    </div>
  );
};
